module.exports = __webpack_public_path__ + "static/media/logo-white.6f6af606.png";